import React, {FC} from 'react';
import {Modal, Button, Typography} from 'antd';
import {useNavigate} from 'react-router-dom';

const {Title, Paragraph} = Typography;

const OnboardingRefreshPage: FC = () => {
    const navigate = useNavigate();

    return (
        <Modal visible title="Onboarding Interrupted" footer={null} closable={false} maskClosable={false}>
            <Title level={4}>Something went wrong</Title>
            <Paragraph>
                It looks like you didn’t finish setting up your payout details.
                Please complete your profile before withdrawing.
            </Paragraph>
            <div style={{textAlign: 'right'}}>
                <Button type="primary" onClick={() => navigate('/profile')}>Go to Profile</Button>
            </div>
        </Modal>
    );
};

export default OnboardingRefreshPage;